import { onUnmounted } from "@vue/composition-api";
import Vue from "vue";
import cssLink from '!!file-loader!sass-loader!./css-reset.css';
const counter = Vue.observable({ value: 0 });
let linkEl = null;
export function useGogoCssReset() {
    counter.value++;
    if (counter.value === 1) {
        linkEl?.remove();
        linkEl = document.createElement('link');
        linkEl.rel = 'stylesheet';
        linkEl.href = cssLink;
        linkEl.setAttribute('data-wuji-gogo-reset', '1');
        document.head.appendChild(linkEl);
    }
    onUnmounted(() => {
        counter.value--;
        if (counter.value === 0) {
            linkEl?.remove();
            linkEl = null;
        }
    });
}
